import { noop } from 'lodash';
import { createContext, FC, useCallback, useMemo, useState } from 'react';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { settings, useSetting } from '../../settings';

export type IOverlayFullscreenContextProps = {
  fullscreen: boolean;
  setFullscreen: (fullscreen: boolean) => void;
  setSettingsKey: (key: string) => void;
};

export const OverlayFullscreenContext =
  createContext<IOverlayFullscreenContextProps>({
    fullscreen: false,
    setFullscreen: noop,
    setSettingsKey: noop,
  });

export interface IOverlayFullscreenProviderProps {
  children?: React.ReactNode;
  entityType?: Entities | undefined;
}

export const OverlayFullscreenProvider: FC<IOverlayFullscreenProviderProps> = (
  props
) => {
  const { entityType } = props;
  const { search } = window.location;

  const [settingsKey, setSettingsKey] = useState<string>(null);

  const maskState = useSetting(
    settings.mask({ entityType: settingsKey || entityType })
  );
  const fullscreenSearchParam = JSON.parse(
    new URLSearchParams(search).get('fullscreen')
  );
  const fullscreen =
    fullscreenSearchParam ?? maskState.value.fullscreen ?? false;

  const setFullscreen = useCallback(
    (fullscreen: boolean) => {
      if (!settingsKey && !entityType) return;

      maskState.set({ ...maskState.value, fullscreen });
    },
    [entityType, maskState, settingsKey]
  );

  const contextValue = useMemo<IOverlayFullscreenContextProps>(
    () => ({
      fullscreen,
      setFullscreen,
      setSettingsKey,
    }),
    [fullscreen, setFullscreen, setSettingsKey]
  );

  return (
    <OverlayFullscreenContext.Provider value={contextValue}>
      {props.children}
    </OverlayFullscreenContext.Provider>
  );
};
